import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IPayByWebProps } from '../../types/propTypes/propTypes';
import { Common } from '../../utils/constants';
import { Can } from '../../ability';
import PayByWebGrid from './PayByWebGrid';
import { companyNameReplace } from '../../utils';

class PayByWeb extends Component<IPayByWebProps & WithTranslation> {
    render() {
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(this.props.t('payByWeb.title'))}</title>
                </Helmet>
                <Can I={Common.Actions.CAN_VIEW} a={Common.Modules.PAY_BY_WEB}>
                    <PayByWebGrid t={this.props.t} />
                </Can>
            </>
        );
    }
}

export default withTranslation()(PayByWeb);
